import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { KnowledgeCenterBoxWrapper } from './KnowledgeCenterBoxUglyStyled'
import IMAGES from '../../images'

const KnowledgeCenterBoxUgly = props => {
  const { data, direction, position } = props
  const [openModal, setOpenModal] = useState(false)

  return (
    <KnowledgeCenterBoxWrapper position={position}>
      <img className={'ugly-girl'} src={IMAGES.UGLY_GIRL} alt={'lady'} />
    </KnowledgeCenterBoxWrapper>
  )
}

KnowledgeCenterBoxUgly.propTypes = {
  data: PropTypes.object,
  position: PropTypes.object,
  direction: PropTypes.object,
}

export default KnowledgeCenterBoxUgly
